import { createContext } from "react";
import type { IFlowBuilderContext } from "../index";

// @ts-expect-error
const BuilderContext = createContext<IFlowBuilderContext>(null);

export default BuilderContext;
